import { useEffect, useState } from 'react'
import Slides from '../slides/Slides';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuthContext } from '../../context/authContext';
import { WebService } from '../../services/webService';

const Cuestionario = ({M}) => {
   const { id } = useParams();
   const { nominaID, identity, nominaNombre, nominaDNI } = useAuthContext();
   const [preguntas,setPreguntas] = useState();
   
   const getCuestionario = async () => {
      try {
         const data = await WebService.getCuestionario(id);
         setPreguntas(data || []);
      } catch (error) {
         Swal.fire({
            icon: "error",
            title: "Error!",
            text: "No se pudo cargar el cuestionario",
            confirmButtonColor: "#147B9C",
         });
      }
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);
      formData.append("nomina_id", nominaID);
      formData.append("email", identity);
      formData.append("nomina_nombre", nominaNombre);
      formData.append("nomina_dni", nominaDNI);
      axios
      .post(`${process.env.REACT_APP_API_URL}/web/resultado/${id}`,formData)
      .then((payload) => {
         Swal.fire({
            icon: payload.data.icon,
            title: payload.data.title,
            text: payload.data.message,
            showConfirmButton: true,
            confirmButtonText: "Ok",
         }).then((response) => {});
      }).catch((error) => {
         Swal.fire({
            icon: "error",
            title: "Error!",
            text: error.response.data.error,
            showConfirmButton: true,
            confirmButtonText: "Ok",
         });
      });
   }
   
   useEffect(() => {
      getCuestionario();
   }, []);
   return (
      <>
         <Slides M={M} tipoSlides={"cuestionario"} />
         <div className="container animated fadeIn" style={{ padding: '20px 0' }}>
            <div className="section">
               {/* BOTÓN VOLVER */}
               <div className="row" style={{ marginBottom: '20px' }}>
                  <div className="col s12 m12">
                     <Link 
                        className="btn waves-effect waves-light light-blue accent-3 hoverable" 
                        to={"/cursos"}
                        style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600' }}
                     >
                        <i className="material-icons left" style={{ marginRight: '6px' }}>arrow_back</i>
                        Volver Atrás
                     </Link>
                  </div>
               </div>
               {/* FORMULARIO DEL CUESTIONARIO */}
               <div className="row">
                  <div className="col s12 m12 l12 xl12">
                     <form onSubmit={handleSubmit}>
                        <div className="card z-depth-2" style={{ borderRadius: '12px', border: 'none' }}>
                           <div className="card-content" style={{ padding: '40px 35px' }}>
                              {preguntas?.map((p, pIndex) => {
                                 return (
                                    <div key={p.pregunta_id || pIndex} style={{ marginBottom: '40px', borderBottom: pIndex < preguntas.length - 1 ? '1px solid #e0e0e0' : 'none', paddingBottom: pIndex < preguntas.length - 1 ? '30px' : '0' }}>
                                       {/* PREGUNTA */}
                                       <span className="card-title" style={{ fontWeight: '700', fontSize: '1.25rem', color: '#37474f', marginBottom: '20px', display: 'block' }}>
                                          {pIndex + 1}. {p.pregunta_pregunta}
                                       </span>
                                       {/* IMAGEN DE LA PREGUNTA (SI EXISTE) */}
                                       {p.pregunta_imagen !== null && (
                                          <div className="center" style={{ margin: '20px 0' }}>
                                             <img 
                                                className="materialboxed responsive-img" 
                                                width="300" 
                                                src={`/app.latitud/img/cursos/${p.pregunta_imagen}`} 
                                                alt="Ilustración de la pregunta"
                                                style={{ borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
                                             />
                                          </div>
                                       )}
                                       {/* OPCIONES DE RESPUESTA */}
                                       <ul style={{ marginTop: '15px', paddingLeft: '10px' }}>
                                          {p.respuestas?.map((r, rIndex) => {
                                             return (
                                                <li key={r.respuesta_id || rIndex} style={{ margin: '12px 0' }}>
                                                   <label style={{ cursor: 'pointer', fontSize: '1.05rem' }}>
                                                      {r.respuesta_check_radio === "1" ? (
                                                         <input 
                                                            type="checkbox" 
                                                            value={r.respuesta_id} 
                                                            name={`respuesta_check[${r.respuesta_id}]`}
                                                            className="filled-in"
                                                         />
                                                      ) : (
                                                         <input 
                                                            type="radio" 
                                                            value={r.respuesta_id} 
                                                            name={`respuesta_radio[${p.pregunta_id}]`}
                                                         />
                                                      )}
                                                      <span className="blue-text text-darken-2" style={{ fontWeight: '500' }}>
                                                         <i>{r.respuesta_respuesta}</i>
                                                      </span>
                                                   </label>
                                                </li>
                                             );
                                          })}
                                       </ul>
                                    </div>
                                 );
                              })}
                              {/* BOTÓN FINALIZAR */}
                              <div className="row" style={{ marginTop: '30px', marginBottom: '0' }}>
                                 <div className="col s12 m12 center-align">
                                    <button 
                                       className="btn waves-effect waves-light light-blue accent-3 hoverable" 
                                       type="submit" 
                                       name="action"
                                       style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', padding: '0 36px', height: '46px', lineHeight: '46px', fontSize: '1.1rem' }}
                                    >
                                       Finalizar
                                       <i className="material-icons right" style={{ marginLeft: '6px' }}>send</i>
                                    </button>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
}

export default Cuestionario